import { render, staticRenderFns } from "./ResetPw.vue?vue&type=template&id=690e021e&scoped=true&"
import script from "./ResetPw.vue?vue&type=script&lang=js&"
export * from "./ResetPw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e021e",
  null
  
)

export default component.exports